import { render, staticRenderFns } from "./chatBox.vue?vue&type=template&id=fefc047a&scoped=true&"
import script from "./chatBox.vue?vue&type=script&lang=js&"
export * from "./chatBox.vue?vue&type=script&lang=js&"
import style0 from "./chatBox.vue?vue&type=style&index=0&id=fefc047a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefc047a",
  null
  
)

export default component.exports